import { REFACTOR_API_URL } from '../../auth/constants'
import { API_URL } from '../constants'

export const homePatientExportSummary = (token: string): {} => {
  const ENDPOINT: RequestInfo = `${REFACTOR_API_URL}/alerts/summary`

  const parameters: RequestInit = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Host: `${REFACTOR_API_URL}`,
      Authorization: `Bearer ${token}`,
    },
    mode: 'cors',
  }

  let status = 0

  return fetch(ENDPOINT, parameters)
    .then((response) => {
      status = response.status
      return response.json()
    })
    .then((data) => {
      return { data, status }
    })
    .catch((e) => {
      console.error(e)
    })
}

export const homePatientSummary = (token: string): {} => {
  const ENDPOINT: RequestInfo = `${API_URL}/patient/summary`
  
  return fetchData(ENDPOINT, token)
}

export const homeBillingSummary = (token: string): {} => {
  const ENDPOINT: RequestInfo = `${REFACTOR_API_URL}/billing/summary`
  
  return fetchData(ENDPOINT, token)
}
export const homePrescriptionsSummary = (token: string): {} => {
  console.log(`service`)
  const ENDPOINT: RequestInfo = `${REFACTOR_API_URL}/prescriptions/summary`
  
  return fetchData(ENDPOINT, token)
}

export const homeInclusionSummary = (token: string): {} => {
  const ENDPOINT: RequestInfo = `${REFACTOR_API_URL}/crm-implantation-enrollment/summary`
  
  return fetchData(ENDPOINT, token)
}

export const refreshTokenService = (token: string): {} => {
  const ENDPOINT: RequestInfo = `${API_URL}/refresh-token`

  return fetchData(ENDPOINT, token)
}

const fetchData = (endPoint: string, token: string) : {} => {
  const parameters: RequestInit = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    Host: `${API_URL}`,
    Authorization: `Bearer ${token}`,
  },
  mode: 'cors',
}

let status = 0

return fetch(endPoint, parameters)
    .then((response) => {
      status = response.status
      return response.json()
    })
    .then((data) => {
      return { data, status }
    })
    .catch((e) => {
      console.error(e)
    })
}
